import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-341" data-mp="32onj8zjvni7d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342" data-mp="36oxzd51dvozy">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-343" data-mp="36nd75m2jki59">
          {/* Company Info */}
          <div className="lg:col-span-1" data-id="element-344" data-mp="38qu4u3bljp2">
            <a href="#" className="inline-flex items-center mb-6 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-4 focus-visible:ring-offset-gray-950" data-id="element-345" data-mp="37o2ul235f8m">
              <Logo variant="dark" size="sm" data-id="element-346" data-mp="29z6tk9nn6feu" />
            </a>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-347" data-mp="29xlzsm95j0i1">
              Marketing Experts at Driving & Turning Traffic into Conversions
              with a Focus on Building Customer Loyalty & Retention.
            </p>
            <div className="space-y-3 text-sm" data-id="element-348" data-mp="3lbdaunotrzj6">
              <a href="tel:17022134801" className="flex items-center hover:text-white transition-colors" data-id="element-349" data-mp="3gbijyk51v9y4">
                <PhoneIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-350" data-mp="3q8mz400ha55f" />
                (702) 213-4801
              </a>
              <a href="mailto:Results@GetAdROI.com" className="flex items-center hover:text-white transition-colors" data-id="element-351" data-mp="82ienymgqkhh">
                <MailIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-352" data-mp="31up7hdvubpd" />
                Results@GetAdROI.com
              </a>
              <div className="flex items-start" data-id="element-353" data-mp="ctqrz5qwypzx">
                <MapPinIcon className="w-4 h-4 mr-3 text-gray-500 mt-1 flex-shrink-0" data-id="element-354" data-mp="cu8tohwchwf8" />
                <span data-id="element-355" data-mp="quji7ea6myx8">
                  4730 S. Fort Apache Rd., Suite 300
                  <br data-id="element-356" data-mp="msg6cojlpsbf" />
                  Las Vegas, NV 89147
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-357" data-mp="tt9z0dyrgtw6">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-358" data-mp="yu7iquzf5vzs">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-359" data-mp="13t0y6sy9nx2l">
              <li data-id="element-360" data-mp="13r7nn2kj8spb">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-361" data-mp="18k0ubvzkab41">
                  Search Engine Optimization
                </a>
              </li>
              <li data-id="element-362" data-mp="1clckc2mckycr">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-363" data-mp="1cnyqpyxi57te">
                  Pay-Per-Click Advertising
                </a>
              </li>
              <li data-id="element-364" data-mp="1ml3gs9ugxnfh">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-365" data-mp="1mkjvqk9iuix8">
                  Web Design & Development
                </a>
              </li>
              <li data-id="element-366" data-mp="3obx0n9bhoqta">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-367" data-mp="3ocghsntbfb69">
                  CRM Implementation
                </a>
              </li>
              <li data-id="element-368" data-mp="2af3upvql3dm9">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-369" data-mp="2afn76wxgt9sw">
                  Conversion Rate Optimization
                </a>
              </li>
              <li data-id="element-370" data-mp="25mkess4fc6ea">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-371" data-mp="21mjzl59i3r66">
                  Social Media Marketing
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-372" data-mp="2te9cko00ln2m">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-373" data-mp="2tcy62gf6q17t">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-374" data-mp="2pd5urvyepgyr">
              <li data-id="element-375" data-mp="2kcrxn8ycfrfi">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-376" data-mp="2kc8iu13zpj5p">
                  About Us
                </a>
              </li>
              <li data-id="element-377" data-mp="2fgkrbf21cdx1">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-378" data-mp="18xuwx1ssrdsb">
                  Our Process
                </a>
              </li>
              <li data-id="element-379" data-mp="13y9u2gaialab">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-380" data-mp="13xqgtcvswl2m">
                  Case Studies
                </a>
              </li>
              <li data-id="element-381" data-mp="2wmzjwjvx0pwq">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-382" data-mp="2wnhk1rlp7o9x">
                  Careers
                </a>
              </li>
              <li data-id="element-383" data-mp="2it86h0f2clvq">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-384" data-mp="2ntw7mex0aj3o">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-385" data-mp="3fl1zk82kpahv">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-386" data-mp="3flljfubsa8yj">
              Resources
            </h4>
            <ul className="space-y-3 text-sm mb-6" data-id="element-387" data-mp="31l0zuvy1o93z">
              <li data-id="element-388" data-mp="36kdn3hstvi73">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-389" data-mp="36juc6l1lhu2k">
                  Marketing Blog
                </a>
              </li>
              <li data-id="element-390" data-mp="1q8glrf97au06">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-391" data-mp="1v5grtq61vwra">
                  ROI Calculator
                </a>
              </li>
              <li data-id="element-392" data-mp="1nkmu4p1tpbct">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-393" data-mp="1no281ojrgecn">
                  Free SEO Audit
                </a>
              </li>
              <li data-id="element-394" data-mp="1wmw0d2q26ike">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-395" data-mp="1wlcjpb0hq5i3">
                  Help Center
                </a>
              </li>
            </ul>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-396" data-mp="13xp1g2mozqym">
              Follow Us
            </h4>
            <div className="flex space-x-4" data-id="element-397" data-mp="zxek5ttg9e4g">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-398" data-mp="zuk0w5m69zcm">
                <FacebookIcon className="w-5 h-5" data-id="element-399" data-mp="18wjmlb84trlw" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-400" data-mp="18v8j7cilmlvb">
                <TwitterIcon className="w-5 h-5" data-id="element-401" data-mp="g95srlzqdc60" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-402" data-mp="2gan75yt2jgyo">
                <InstagramIcon className="w-5 h-5" data-id="element-403" data-mp="2l8oqmkuepiao" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-404" data-mp="2q0oyczgpxfht">
                <LinkedinIcon className="w-5 h-5" data-id="element-405" data-mp="2uyi4xtlxobim" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-406" data-mp="1xdcc6qegz9p1">
          <p data-id="element-407" data-mp="279ytx6bi1kmu">
            &copy; {new Date().getFullYear()} AdROI Marketing & Conversions. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-408" data-mp="2bbspj06u7yg5">
            <a href="#" className="hover:text-white transition-colors" data-id="element-409" data-mp="2b97pmgq3nsl1">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-410" data-mp="3mqft8zsx94o5">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-411" data-mp="1b3m25g15kp45">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}